import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_1: FaireProductEntity = {
  token: "atc_updated_fs_rec_1",
  type: "product",
  name: "Artisan Glassware & Bowl Set",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fa8b92ee356b8f76b20c22066156741f00d627decc01830e7216bbe2320e7b1b.webp",
  priceDollars: 42,
  msrpDollars: 84,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
